import React from 'react';

import { connect } from 'react-redux';

import appConfigs from '@nerdwallet/app-config';

import { WithURLRecord } from '../../components/url-record';
import type { UrlRecordOptions } from '../../components/url-record';
import getTaxonomy from '../../lib/page-taxonomy';

import MCStateResults, { MCStateResultsProps } from './mc-state-results';

const URL_RECORD_OPTIONS: UrlRecordOptions = {
  url: () => `${appConfigs.SITE_BASE_URL}/mortgages/mortgage-calculator/STATE`,
  metadataOptions: (props) => {
    return {
      nerdLayoutMappings: { pageTaxonomy: getTaxonomy('mc') },
      variables: {
        stateName: props?.stateName,
      },
      url: (url) =>
        url ? url.replace('STATE', props?.params?.stateSlug) : url,
    };
  },
};
const MCStateResultsWrapper = (props: MCStateResultsProps): JSX.Element => {
  return (
    <WithURLRecord
      {...props}
      options={URL_RECORD_OPTIONS}
      component={MCStateResults}
    />
  );
};

const mapStateToProps = (state) => {
  return {
    stateName: state?.mortgageCalculator?.stateData?.stateName,
  };
};

export default connect(mapStateToProps)(MCStateResultsWrapper);
